import { type ISelectProps } from '@procurify/ui'

import { TaxFormModal } from '@webapp/components/TaxForm'
import { TaxSelect } from '@webapp/components/TaxSelect'
import { useProcurifyIntl } from '@webapp/hooks'
import { type Tax } from '@webapp/models'
import messages from './messages'
import { useTaxSelectCreate } from './useTaxSelectCreate'

export interface TaxSelectCreateProps extends ISelectProps<Tax> {
  id?: string
  inputId?: string
  name?: string
  onTaxCreated: (tax: Tax) => void
  onTaxSelected: (tax: Nullable<Tax>) => void
  onModalOpen?: () => void
  onModalClose?: () => void
  onMenuOpen?: () => void
  onMenuClose?: () => void
}

export const TaxSelectCreate = ({
  isDisabled = false,
  id,
  inputId,
  name,
  placeholder,
  value,
  menuPortalTarget,
  onTaxCreated,
  onTaxSelected,
  onModalOpen,
  onModalClose,
  onMenuOpen,
  onMenuClose,
  analyticsId,
}: TaxSelectCreateProps) => {
  const intl = useProcurifyIntl()

  const {
    createTax,
    taxOptions,
    isTaxOptionsLoading,
    isTaxFormModalOpen,
    setIsTaxFormModalOpen,
  } = useTaxSelectCreate({ onTaxCreated, onModalClose })

  return (
    <>
      <TaxSelect
        id={id}
        inputId={inputId}
        name={name}
        aria-label={intl.formatMessage(messages.taxSelectAriaLabel)}
        isClearable
        isDisabled={isDisabled || isTaxOptionsLoading}
        menuPortalTarget={menuPortalTarget}
        onChange={(selectedTax: Nullable<Tax>) => onTaxSelected(selectedTax)}
        onCreateTax={() => {
          onModalOpen?.()
          setIsTaxFormModalOpen(true)
        }}
        options={taxOptions}
        placeholder={
          placeholder || intl.formatMessage(messages.defaultPlaceholderText)
        }
        value={value}
        analyticsId={analyticsId}
        onMenuOpen={onMenuOpen}
        onMenuClose={onMenuClose}
      />
      <TaxFormModal
        open={isTaxFormModalOpen}
        onSubmit={(taxFormData) => createTax(taxFormData)}
        onDismiss={() => {
          setIsTaxFormModalOpen(false)
          onModalClose?.()
        }}
      />
    </>
  )
}
